{
  "CANNED_MGMT": {
    "HEADER": "Răspunsuri predefinite",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Add canned response",
    "LOADING": "Fetching canned responses...",
    "SEARCH_404": "Nu există elemente care să corespundă acestei interogări.",
    "LIST": {
      "404": "Nu există răspunsuri predefinite disponibile în acest cont.",
      "TITLE": "Gestionare Răspunsuri predefinite",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Short code",
        "CONTENT": "Conținut",
        "INBOXES": "Inbox-uri",
        "ACTIONS": "Actiuni"
      },
      "ALL_INBOXES": "Toate inbox-urile",
      "FILTER": {
        "ALL_INBOXES": "Toate inbox-urile",
        "NO_INBOX": "Fără inbox",
        "SEARCH_PLACEHOLDER": "Caută inbox-uri"
      }
    },
    "ADD": {
      "TITLE": "Add canned response",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a short code.",
          "ERROR": "Short Code is required."
        },
        "SUBJECT": {
          "LABEL": "Subiect (doar e-mail)",
          "PLACEHOLDER": "Subiect opțional pentru răspunsuri e-mail / conversații noi"
        },
        "CONTENT": {
          "LABEL": "Mesaj",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Atașamente"
        },
        "INBOXES": {
          "LABEL": "Inbox-uri",
          "PLACEHOLDER": "Selectați inbox-uri (opțional, lăsați gol pentru toate inbox-urile)"
        },
        "SUBMIT": "Trimite"
      },
      "API": {
        "SUCCESS_MESSAGE": "Canned response added successfully.",
        "ERROR_MESSAGE": "Nu s-a putut conecta la serverul Woot. Vă rugăm să încercați din nou."
      }
    },
    "EDIT": {
      "TITLE": "Edit canned response",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a shortcode.",
          "ERROR": "Short code is required."
        },
        "SUBJECT": {
          "LABEL": "Subiect (doar e-mail)",
          "PLACEHOLDER": "Subiect opțional pentru răspunsuri e-mail / conversații noi"
        },
        "CONTENT": {
          "LABEL": "Mesaj",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Este necesar un mesaj."
        },
        "ATTACHMENTS": {
          "LABEL": "Atașamente"
        },
        "INBOXES": {
          "LABEL": "Inbox-uri",
          "PLACEHOLDER": "Selectați inbox-uri (opțional, lăsați gol pentru toate inbox-urile)"
        },
        "SUBMIT": "Trimite"
      },
      "BUTTON_TEXT": "Editare",
      "API": {
        "SUCCESS_MESSAGE": "Canned response is updated successfully.",
        "ERROR_MESSAGE": "Nu s-a putut conecta la serverul Woot. Vă rugăm să încercați din nou."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Şterge",
      "API": {
        "SUCCESS_MESSAGE": "Canned response deleted successfully.",
        "ERROR_MESSAGE": "Nu s-a putut conecta la serverul Woot. Vă rugăm să încercați din nou."
      },
      "CONFIRM": {
        "TITLE": "Confirmă ștergerea",
        "MESSAGE": "Sigur doriți să ștergeți ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
